var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "plans-container" },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("message.planManagement") }],
            select: true,
          },
        },
        [
          _c(
            "a-button",
            {
              staticClass: "actionButtonBreadcrumb",
              on: {
                click: function ($event) {
                  _vm.modalShowing = true
                },
              },
            },
            [
              _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
              _vm._v(_vm._s(_vm.$t("message.create")) + "\n        "),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.deleteItem,
            icon: "exclamation-circle",
            title: _vm.$t("message.plansDeletePackageTitle"),
          },
          on: {
            cancel: function ($event) {
              _vm.deleteItem = null
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteItem = null
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deletePackage },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_c("p", [_vm._v(_vm._s(_vm.$t("message.plansDeletePackageConfirm")))])]
      ),
      _vm._v(" "),
      _vm.modalShowing
        ? _c("CreateNewPlanModal", {
            on: {
              cancel: function ($event) {
                _vm.modalShowing = false
              },
              create: _vm.createNewPlan,
              update: _vm.planUpdate,
            },
            model: {
              value: _vm.form,
              callback: function ($$v) {
                _vm.form = $$v
              },
              expression: "form",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "plan-container breadcrumb-content" }, [
        _c(
          "div",
          { staticClass: "sidebar" },
          [
            _c("PlanMenu", {
              attrs: { types: Object.keys(_vm.plans) },
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "plan-container-content" },
          [
            !Object.keys(_vm.plans).length
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center",
                      height: "80%",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "flex-direction": "column",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "material-icons",
                            staticStyle: { "font-size": "150px" },
                          },
                          [_vm._v(" sentiment_very_dissatisfied ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "font-size": "26px",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.plansEmptyState")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              background: "rgb(236, 75, 29)",
                              color: "white",
                              display: "flex",
                              "justify-content": "center",
                              "align-items": "center",
                              padding: "10px 15px",
                              "border-radius": "100px",
                              "user-select": "none",
                              cursor: "pointer",
                              "margin-top": "20px",
                            },
                            on: { click: _vm.planSeed },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.plansDefinePackages")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._l(
                  Object.keys(_vm.plans).filter(function (type) {
                    return type === _vm.currentTab
                  }),
                  function (planName) {
                    return _c("div", { staticClass: "plan" }, [
                      _c("div", { staticClass: "plan-title" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              planName
                                .split("-")
                                .map(function (c) {
                                  return (
                                    c[0].toUpperCase() +
                                    c.slice(1).toLowerCase()
                                  )
                                })
                                .join(" ")
                            ) +
                            "\n                    " +
                            _vm._s(_vm.$t("message.plansPackagesSuffix")) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("transition", { attrs: { name: "scale" } }, [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.plans[planName].length > 4 &&
                                      _vm.prevButton,
                                    expression:
                                      "plans[planName].length > 4 && prevButton",
                                  },
                                ],
                                class: {
                                  "scale-in": _vm.prevButton,
                                  "scale-out": !_vm.prevButton,
                                },
                                attrs: { id: "prev-button" },
                                on: { click: _vm.previousPlan },
                              },
                              [
                                _c(
                                  "md-icon",
                                  {
                                    staticClass: "navigate-arrow navigate-left",
                                  },
                                  [_vm._v("arrow_back_ios_new")]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              ref: "plansContainer",
                              refInFor: true,
                              staticClass: "items",
                            },
                            _vm._l(_vm.plans[planName], function (item) {
                              return _c("Card", {
                                key: item._id,
                                staticClass: "plan-card",
                                attrs: {
                                  plan: item,
                                  "editable-card": true,
                                  details: {
                                    agentCount: 1,
                                    whatsappChannel: 1,
                                  },
                                },
                                on: {
                                  "edit-action": function ($event) {
                                    return _vm.editPlan(item)
                                  },
                                  "delete-action": function ($event) {
                                    _vm.deleteItem = item
                                  },
                                },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("transition", { attrs: { name: "scale" } }, [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.plans[planName].length > 4 &&
                                      _vm.nextButton,
                                    expression:
                                      "plans[planName].length > 4 && nextButton",
                                  },
                                ],
                                class: {
                                  "scale-in": _vm.nextButton,
                                  "scale-out": !_vm.nextButton,
                                },
                                attrs: { id: "next-button" },
                                on: { click: _vm.nextPlan },
                              },
                              [
                                _c(
                                  "md-icon",
                                  {
                                    staticClass:
                                      "navigate-arrow navigate-right",
                                  },
                                  [_vm._v("arrow_forward_ios")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ])
                  }
                ),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }